import { api } from '../api';
import { links } from '../../../data/links';

export const eventLogApi = api.injectEndpoints({
  endpoints: build => ({
    createEventLog: build.mutation({
      query({ token, data }) {
        return {
          url: links.eventLogs,
          method: 'POST',
          body: data,
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      invalidatesTags: (result, error) =>
        !error ? [{ type: 'EventLog', id: 'LIST' }] : [],
    }),

    getEventLogsBySubject: build.query({
      query({ token, subjectType, subjectId }) {
        return {
          url: `${links.eventLogs}?subject_type=${subjectType}&subject_id=${subjectId}`,
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      transformResponse: responseData => responseData?.data || [],
      providesTags: [{ type: 'EventLog', id: 'LIST' }],
    }),

    getEventLogsByActor: build.query({
      query({ token, actorId }) {
        return {
          url: `${links.eventLogs}?actor_id=${actorId}`,
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      transformResponse: responseData => responseData?.data || [],
      providesTags: [{ type: 'EventLog', id: 'LIST' }],
    }),
  }),
});

export const {
  useCreateEventLogMutation,
  useGetEventLogsBySubjectQuery,
  useGetEventLogsByActorQuery,
} = eventLogApi;

export const EVENT_LOG_TYPES = Object.freeze({
  PROPERTY_VIEWED: 'property.viewed',
  PROPERTY_SHARED: 'property.shared',
  CLIENT_DOCUMENT_DOWNLOADED: 'client.document_downloaded',
  USER_WHATSAPP_SENT: 'user.whatsapp_sent',
  USER_MESSAGE_SENT: 'user.message_sent',
});

export const EVENT_LOG_SUBJECTS = Object.freeze({
  REALTY: 'realty',
  CLIENT: 'client',
  CLIENT_REQUEST: 'client_request',
  REMINDER: 'reminder',
});
